/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ok': {
    width: 15,
    height: 12,
    viewBox: '0 0 15 12',
    data: '<path pid="0" _fill="inherit" d="M5.54 9.216L1.904 6.292a1.174 1.174 0 00-1.644.172 1.156 1.156 0 00.173 1.634l4.531 3.643c.497.4 1.223.329 1.633-.158l8.131-9.677A1.156 1.156 0 0014.58.27a1.174 1.174 0 00-1.646.147l-7.394 8.8z"/>'
  }
})
